import hero from '../assets/web/hero-colazione.jpg';
import cappuccino from '../assets/web/caffetteria-cappuccino.jpg';
import bancone from '../assets/web/caffetteria-bancone.jpg';
import cornetti from '../assets/web/caffetteria-cornetti.jpg';
import piadina from '../assets/web/pranzo-piadina.jpg';
import hamburger from '../assets/web/pranzo-hamburger.jpg';
import aperitivoTavolo from '../assets/web/aperitivo-tavolo.jpg';
import aperitivoTagliere from '../assets/web/aperitivo-tagliere.jpg';
import aperitivoSpritz from '../assets/web/aperitivo-spritz.jpg';
import locale from '../assets/web/bancone-locale.jpg';
import menuCaffetteria from '../assets/web/menu-caffetteria.jpg';
import menuPranzo from '../assets/web/menu-pranzo.jpg';

// Le dimensioni riservano lo spazio prima del caricamento e definiscono le proporzioni delle foto.
const images = {
  hero: { src: hero, width: 1800, height: 1350 },
  cappuccino: { src: cappuccino, width: 1400, height: 1081 },
  bancone: { src: bancone, width: 1200, height: 900 },
  cornetti: { src: cornetti, width: 1200, height: 900 },
  piadina: { src: piadina, width: 900, height: 1200 },
  hamburger: { src: hamburger, width: 1200, height: 900 },
  aperitivoTavolo: { src: aperitivoTavolo, width: 1600, height: 1200 },
  aperitivoTagliere: { src: aperitivoTagliere, width: 1400, height: 1050 },
  aperitivoSpritz: { src: aperitivoSpritz, width: 675, height: 1200 },
  locale: { src: locale, width: 863, height: 646 },
  menuCaffetteria: { src: menuCaffetteria, width: 596, height: 843 },
  menuPranzo: { src: menuPranzo, width: 596, height: 843 },
};

export default images;
